import cz from '../csCZ/contact_form';

const de: typeof cz = {
	fields: {
		name: 'Name',
		email: 'Email',
		question: 'Nachfrage',
	},
	submit_button: 'Senden',
	question_submitted: 'Frage senden',
};

export default de;
